"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

import { QueryClient, QueryClientProvider } from "@jti/rest-api";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const WebPushNotificationsDynamic = dynamic(
  async () => (await import("@jti/ui/WebPushNotifications")).WebPushNotifications,
  { ssr: false }
);

export const WebPushNotifications = () => {
  const pathname = usePathname();

  return (
    <QueryClientProvider client={client}>
      <WebPushNotificationsDynamic pathname={pathname} />
    </QueryClientProvider>
  );
};
